module.exports = __webpack_public_path__ + "img/2-colorful.b62f92d1.png";